<!--<div class="notification-message-container m-0 m-b-10" fxLayoutAlign="space-between center">-->
<!--  <div>-->
<!--    <span>Note:</span> <span>The following keyterms will be used when auto-suggesting Hallmarks for a particular Case, based on the Case Description.</span>-->
<!--  </div>-->
<!--</div>-->
<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
    <mat-label>Write a keyword for Hallmark suggestion</mat-label>
    <input type="text" matInput formControlName="value" placeholder="Write a keyword for Hallmark suggestion"
           [matAutocomplete]="auto"/>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
        {{option}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-button class="common-button m-b-24 m-l-20" (click)=search() style="position: relative;top: 4px">Search
  </button>
</form>
<div class="holmark-tag-container m-t-20 full-grow-no-shrink-no-basis">
  <div *ngFor="let hallmark of hallmarkInfo" class="w-p-100 flex flex-row justify-start items-center">
    <mat-checkbox [checked]="hallmark.isChecked" disabled="true">{{hallmark.header}}</mat-checkbox>

    <div class="buttons-container flex flex-row justify-start items-center">
      <!--
      <button mat-button class="link-button" (click)="navigateToHallmark(hallmark)">Go to Details</button>
      <div class="divider"></div>
      -->
      <button mat-button class="link-button" (click)="openHallmarkTaggingDialog(hallmark)">Add Tagging</button>
    </div>
  </div>
</div>
